import * as ACTIONTYPES from '../constants/actiontypes';
import {
  getIdOfHiddingTimer,
  getControlsVisibility,
  getIsControlsOnHover,
} from '../selectors/selectors'

export const toggleControlsVisibility = () => (dispatch, getState) => {
  const isControlsVisible = getControlsVisibility(getState());
  if (isControlsVisible) {
    dispatch(hideControls());
    dispatch(clearTimerOfHidding());
  } else {
    dispatch(showControls());
  }
}
  // ({
  // type: ACTIONTYPES.CONTROLS_TOGGLE_VISIBILITY,
  // isVisible: visibility
  // })
  ;

export const toggleControlsHover = isControlsHover => ({
  type: ACTIONTYPES.CONTROLS_TOGGLE_HOVER,
  isControlsHover
});

export const setTimerId = timerId => ({
  type: ACTIONTYPES.SET_TIMER_ID,
  timerId
});

export const showControls = () => (dispatch, getState) => {
  const isControlsVisible = getControlsVisibility(getState())
  if (!isControlsVisible) {
    dispatch({
      type: ACTIONTYPES.CONTROLS_SHOW,
    })
  }
}

export const hideControls = () => (dispatch, getState) => {
  const isControlsVisible = getControlsVisibility(getState())
  if (isControlsVisible) {
    dispatch({
      type: ACTIONTYPES.CONTROLS_HIDE,
    })
  }
}

export const defferedHiding = (timeout = 1500) => (dispatch, getState) => {
  const state = getState()
  const isControlsOnHover = getIsControlsOnHover(state);
  dispatch(clearTimerOfHidding());
  const timerId = setTimeout(() => {
    if (
      !isControlsOnHover
    ) {
      dispatch(hideControls());
    }
  }, timeout);

  dispatch(setTimerId(timerId));
}

export const clearTimerOfHidding = () => (dispatch, getState) => {
  const timerId = getIdOfHiddingTimer(getState());
  if (timerId !== null) {
    clearTimeout(timerId);
    dispatch(setTimerId(null));
  }
}




// WEBPACK FOOTER //
// ./src/store/actions/controls-visibility-actions.js